import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import IconButton from '@material-ui/core/IconButton';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import useTheme from '@material-ui/core/styles/useTheme';

import Icon from 'components/Icon';

import {
  PlTitleDialog,
  PlDialog,
  Title,
  PlDialogContent,
  CancelWrapper,
  CancelButton,
  SubTitle,
} from './dialog.component.view';

interface WrapperDialogProps {
  handleClickOpen: () => void;
  handleClose: () => void;
  open: boolean;
}

interface TitleDialogProps {
  children: React.ReactNode;
  onClose: () => void;
  subTitle?: string;
}

interface DialogProps {
  open: boolean;
  handleClose: () => void;
  title?: string;
  children: React.ReactNode;
  id?: string;
  isReceipt?: boolean;
  isFormDialog?: boolean;
  dividers?: boolean;
  subTitle?: string;
}

const WrapperDialog = (props: { render: CallableFunction }) => {
  const [open, setOpen] = useState<boolean>(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return props.render({
    open,
    handleClickOpen,
    handleClose,
    ...props,
  });
};

const TitleDialog = ({ children, onClose, subTitle }: TitleDialogProps) => {
  return (
    <>
      <PlTitleDialog disableTypography>
        <Title>{children}</Title>
        {onClose ? (
          <IconButton aria-label="close" onClick={onClose}>
            <Icon name="close" />
          </IconButton>
        ) : null}
      </PlTitleDialog>
      <SubTitle>{subTitle}</SubTitle>
    </>
  );
};

const Dialog = ({
  open,
  handleClose,
  title,
  subTitle,
  children,
  id,
  isReceipt = false,
  isFormDialog = false,
  dividers = true,
  ...rest
}: DialogProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));

  const Header = () => {
    if (isFormDialog && matches) {
      return (
        <PlTitleDialog disableTypography>
          <Title>{title}</Title>
        </PlTitleDialog>
      );
    }

    return (
      <TitleDialog onClose={handleClose} subTitle={subTitle}>
        {title}
      </TitleDialog>
    );
  };

  return (
    <PlDialog
      onClose={handleClose}
      aria-labelledby={id}
      open={open}
      PaperProps={{ elevation: 0 }}
      {...rest}
    >
      {title !== null ? <Header /> : null}
      <PlDialogContent dividers={dividers} isreceipt={`${isReceipt}`}>
        {children}
        {isFormDialog && matches && (
          <CancelWrapper>
            <CancelButton onClick={handleClose}>{t('cancel')}</CancelButton>
          </CancelWrapper>
        )}
      </PlDialogContent>
    </PlDialog>
  );
};

export default WrapperDialog;
export { Dialog, WrapperDialogProps };
